import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {
	Component,
} from 'react';



const today = new Date();
const isChristmasTime = (
	isAfter(today, new Date(today.getFullYear(), 11, 1, 0, 0, 0))
	&& isBefore(today, new Date(today.getFullYear(), 11, 27, 23, 59, 59))
);



class AuthScreenLayout extends Component {

	render() {
		const {
			footer,
			children,
			logo,
		} = this.props;

		const componentClasses = classNames({
			'auth-page': true,
			'auth-page--has-footer': footer,
			'auth-page--christmas': isChristmasTime,
			'js-scrollable': true,
		});

		return (
			<div className={componentClasses}>
				<div className="auth-page__kevin-container">
					<div className="auth-page__container">
						<div className="auto-page__logo">
							{logo}
						</div>

						<div className="auth-page__center-wrapper">
							<div className="auth-page__content">
								{children}
							</div>
						</div>
					</div>

					{footer && (
						<div className="auth-page__footer">
							{footer}
						</div>
					)}
				</div>
			</div>
		);
	}

}

AuthScreenLayout.propTypes = {
	/** Additional footer */
	footer: PropTypes.node,
	/** Screen logo component */
	logo: PropTypes.node.isRequired,
};



export default AuthScreenLayout;
